import NiceModal, { useModal } from '@ebay/nice-modal-react'
import React from 'react'
import { createMVPModal } from '../Modal'
import { SelectDeckModalView } from './SelectDeckModalView'
import { usePreferredDeck } from '../../../state/hooks/AppConfigHooks'

class SelectDeckModal
{
	Show() 
	{
		NiceModal.show(createMVPModal('select-deck-modal', () =>
		{
			const modal = useModal()
			const { preferredDeck, setPreferredDeck } = usePreferredDeck()

			const clickDeck = (deck: number) => {
				setPreferredDeck(deck)
			}
		
			const clickClose = () => {
				modal.hide()
			}

			return <SelectDeckModalView 
				preferredDeck={preferredDeck}
				
				clickDeck={clickDeck}
				clickClose={clickClose}
			/>
		}))
	}
}

const modal = new SelectDeckModal()
export default modal